import { RouterReducerState, getRouterSelectors } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectRouter = createFeatureSelector<RouterReducerState>('router');
const selectors = getRouterSelectors(selectRouter);
export const selectPath = createSelector(selectors.selectUrl, url => url?.split('?').shift());
export const fromRouter = { selectPath, ...selectors };
